const $window = $(window);

const handleStickyHeader = () => {
  const $header = $('.header');
  const $notice = $('.header__notice');
  const isSticky = $window.scrollTop() > 0;

  if (isSticky) {
    $header.addClass('header--sticky')
      .css('transform', 'translateY(' + ($notice.outerHeight() * -1) + 'px)');
  } else {
    $header.removeClass('header--sticky')
      .css('transform', 'translateY(0)');
  }
}

$window.on('load resize scroll', function() {
  handleStickyHeader();
});
